<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" :loading="loading">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title> {{ gallery.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary mr-4" @click="openFileExplorer">
              <v-file-input
                v-model="gallery.documents"
                hide-input
                multiple
                id="Documents"
                accept="image/png, image/jpeg, image/jpg ,video/mp4,image/gif"
                prepend-icon=""
                @change="saveimage()"
              ></v-file-input>
              <v-icon left> mdi-camera </v-icon>Add
            </v-btn>
            <v-btn color="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              Back
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7 black--text">
            <v-row>
              <v-col cols="12">
                <v-tabs
                  color="primary"
                  v-model="currentTab"
                  @change="storeSelectedTabValue"
                >
                  <v-tab
                    v-for="tab in tabs"
                    :key="tab.name"
                    :href="'#' + tab.name"
                    :id="tab.name"
                    class="ml-4"
                  >
                    {{ tab.name }}
                  </v-tab>

                  <v-tabs-items v-model="currentTabComponent" class="pa-4">
                    <keep-alive>
                      <component
                      v-bind:is="currentTabComponent"
                      v-bind:loading="loading"
                    ></component>
                    </keep-alive>
                  </v-tabs-items>
                </v-tabs>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import ImageGallery from "../gallery/ImageGallery.vue";
import VideoGallery from "../gallery/VideoGallery.vue";

export default {
  components: {
    ImageGallery,
    VideoGallery,
  },
  data() {
    return {
      loading: false,
      society_id: "",
      tabs: [
        { name: "Image", component: "ImageGallery" },
        { name: "Video", component: "VideoGallery" },
      ],
      currentTab: "",
      search: "",
      gallery: "",
    };
  },
  computed: {
    currentTabComponent: function () {
      let tab = this.tabs.find((tab) => tab.name == this.currentTab);
      return tab ? tab.component : "";
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    ...mapMutations("society", ["setSelectedTab"]),
    storeSelectedTabValue() {
      this.setSelectedTab({
        selectedTab: this.currentTab,
      });
      localStorage.setItem("selectedTab", this.currentTab);
    },
    getGalleryDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/gallery/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.gallery = data.gallery;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
    saveimage() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.gallery.title);
          for (let i = 0; i < this.gallery.documents.length; i++) {
            formData.append("documents[]", this.gallery.documents[i]);
          }
          console.log("documents", this.gallery.documents);
          _self.$axios
            .put("/societyadmin/gallery/" + this.gallery.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;
              _self.loading = false;
              _self.serverSideErrors = {};
              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                    this.setAlert({
                      showAlert: true,
                      message: data.errors[i].message,
                      variant: "green accent-4",
                      timeout: 2000,
                    });
                  }
                }
              }
            });
        }
      });
    },
    openFileExplorer() {
      document.getElementById("Documents").click();
    },
  },
  mounted() {
    const selectedTab = localStorage.getItem("selectedTab");
    if (selectedTab) {
      this.currentTab = selectedTab;
    }
    this.getGalleryDetail();
  },
};
</script>